export const MODAL = {
	Z_INDEX_STANDARD: 2000,
	Z_INDEX_BEHIND_HIT_PMS_HTML_MODAL: 1030,
};
